export const exteriorScenes = {
  exterior01: {
    name: "Main Gate",
    panorama: "/images/Exterior01.jpg",
    thumbnail: "/images/thumbnail/Exterior01.jpg",
    hotspots: [
      {
        id: "to-exterior02",
        yaw: "0deg",
        pitch: "-10deg",
        label: "Entrance",
        target: "exterior02",
        type: "arrow"
      },
    ],
  },
  exterior02: {
    name: "Entrance",
    panorama: "/images/Exterior02.jpg",
    thumbnail: "/images/thumbnail/Exterior02.jpg",
    hotspots: [
      {
        id: "to-exterior03",
        yaw: "-5deg",
        pitch: "0deg",
        label: "Garden 1",
        target: "exterior03",
        type: "arrow",
      },
      {
        id: "to-exterior01",
        yaw: "-40deg",
        pitch: "0deg",
        label: "Main Gate",
        target: "exterior01",
        type: "arrow",
      },
      {
        id: "to-exterior04",
        yaw: "30deg",
        pitch: "0deg",
        label: "Garden 2",
        target: "exterior04",
        type: "arrow",
      },
      {
        id: "to-exterior06",
        yaw: "120deg",
        pitch: "0deg",
        label: "Parking",
        target: "exterior06",
        type: "arrow",
      },
    ],
  },
  exterior03: {
    name: "Garden 1",
    panorama: "/images/Exterior03.jpg",
    thumbnail: "/images/thumbnail/Exterior03.jpg",
    hotspots: [
      {
        id: "to-exterior04",
        yaw: "115deg",
        pitch: "-5deg",
        label: "Garden 2",
        target: "exterior04",
        type: "arrow",
      },
      {
        id: "to-exterior02",
        yaw: "-155deg",
        pitch: "-5deg",
        label: "Entrance",
        target: "exterior02",
        type: "arrow",
      },
      {
        id: "to-exterior05",
        yaw: "130deg",
        pitch: "0deg",
        label: "Plaground",
        target: "exterior05",
        type: "arrow",
      },
      {
        id: "to-exterior07",
        yaw: "125deg",
        pitch: "25deg",
        label: "Balcony",
        target: "exterior07",
        type: "arrow",
      },
    ],
  },
  exterior04: {
    name: "Garden 2",
    panorama: "/images/Exterior04.jpg",
    thumbnail: "/images/thumbnail/Exterior04.jpg",
    hotspots: [
      {
        id: "to-exterior05",
        yaw: "0deg",
        pitch: "0deg",
        label: "Plaground",
        target: "exterior05",
        type: "arrow",
      },
      {
        id: "to-exterior07",
        yaw: "-5deg",
        pitch: "30deg",
        label: "Balcony",
        target: "exterior07",
        type: "arrow",
      },
      {
        id: "to-exterior03",
        yaw: "175deg",
        pitch: "0deg",
        label: "Garden 1",
        target: "exterior03",
        type: "arrow",
      },
      {
        id: "to-exterior02",
        yaw: "135deg",
        pitch: "0deg",
        label: "Entrance",
        target: "exterior02",
        type: "arrow",
      },
    ],
  },
  exterior05: {
    name: "Plaground",
    panorama: "/images/Exterior05.jpg",
    thumbnail: "/images/thumbnail/Exterior05.jpg",
    hotspots: [
      {
        id: "to-exterior06",
        yaw: "40deg",
        pitch: "0deg",
        label: "Parking",
        target: "exterior06",
        type: "arrow"
      },
      {
        id: "to-exterior07",
        yaw: "-12deg",
        pitch: "40deg",
        label: "Balcony",
        target: "exterior07",
        type: "arrow"
      },
      {
        id: "to-exterior04",
        yaw: "180deg",
        pitch: "0deg",
        label: "Garden 2",
        target: "exterior04",
        type: "arrow"
      },
    ],
  },
  exterior06: {
    name: "Parking",
    panorama: "/images/Exterior06.jpg",
    thumbnail: "/images/thumbnail/Exterior06.jpg",
    hotspots: [
      {
        id: "to-exterior07",
        yaw: "44deg",
        pitch: "25deg",
        label: "Balcony",
        target: "exterior07",
        type: "arrow"
      },
      {
        id: "to-exterior05",
        yaw: "0deg",
        pitch: "0deg",
        label: "Playground",
        target: "exterior05",
        type: "arrow"
      },
      {
        id: "to-exterior02",
        yaw: "-58deg",
        pitch: "0deg",
        label: "Entrance",
        target: "exterior02",
        type: "arrow"
      },
    ],
  },
  exterior07: {
    name: "Balcony",
    panorama: "/images/Exterior07.jpg",
    thumbnail: "/images/thumbnail/Exterior07.jpg",
    hotspots: [
      {
        id: "to-exterior01",
        yaw: "-4deg",
        pitch: "-5deg",
        label: "Main Gate",
        target: "exterior01",
        type: "arrow"
      },
      {
        id: "to-exterior03",
        yaw: "5deg",
        pitch: "-10deg",
        label: "Garden 1",
        target: "exterior03",
        type: "arrow"
      },
      {
        id: "to-exterior06",
        yaw: "-47deg",
        pitch: "-22deg",
        label: "Parking",
        target: "exterior06",
        type: "arrow"
      },
    ],
  }
};

export const interiorScenes = {
  interior01: {
    name: "Living Room",
    panorama: "/images/Interior01.jpg",
    thumbnail: "/images/thumbnail/Interior01.jpg",
    defaultYaw: "-90deg",
    defaultPitch: "0deg",
    //      map: {
    //   x: 30,
    //   y: 60,
    //   rotation: "90deg",
    // },
    hotspots: [
      {
        id: "to-interior02",
        yaw: "-60deg",
        pitch: "0deg",
        label: "Kitchen",
        target: "interior02",
        type: "arrow"
      },
      {
        id: "to-interior07",
        yaw: "90deg",
        pitch: "0deg",
        label: "Balcony",
        target: "interior07",
        type: "arrow"
      },
      {
        id: "to-interior03",
        yaw: "0deg",
        pitch: "-10deg",
        label: "Lobby",
        target: "interior03",
        type: "arrow"
      },
    ],
  },
  interior02: {
    name: "Kitchen",
    panorama: "/images/Interior02.jpg",
    thumbnail: "/images/thumbnail/Interior02.jpg",
    hotspots: [
      {
        id: "to-interior03",
        yaw: "125deg",
        pitch: "0deg",
        label: "Lobby",
        target: "interior03",
        type: "arrow"
      },
      {
        id: "to-interior01",
        yaw: "-105deg",
        pitch: "-10deg",
        label: "Living Room",
        target: "interior01",
        type: "arrow"
      },
      {
        id: "to-interior07",
        yaw: "-175deg",
        pitch: "0deg",
        label: "Balcony",
        target: "interior07",
        type: "arrow"
      },
    ],
  },
  interior03: {
    name: "Lobby",
    panorama: "/images/Interior03.jpg",
    thumbnail: "/images/thumbnail/Interior03.jpg",
    hotspots: [
      {
        id: "to-interior04",
        yaw: "40deg",
        pitch: "5deg",
        label: "Bedroom 1",
        target: "interior04",
        type: "arrow"
      },
      {
        id: "to-interior05",
        yaw: "100deg",
        pitch: "5deg",
        label: "Bedroom 2",
        target: "interior05",
        type: "arrow"
      },
      {
        id: "to-interior06",
        yaw: "200deg",
        pitch: "0deg",
        label: "Bedroom 3",
        target: "interior06",
        type: "arrow"
      },
      {
        id: "to-interior01",
        yaw: "-70deg",
        pitch: "0deg",
        label: "Living Room",
        target: "interior01",
        type: "arrow"
      },
    ],
  },
  interior04: {
    name: "Bedroom 1",
    panorama: "/images/Interior04.jpg",
    thumbnail: "/images/thumbnail/Interior04.jpg",
    defaultYaw: "-45deg",
    defaultPitch: "0deg",
    hotspots: [
      {
        id: "to-interior03",
        yaw: "170deg",
        pitch: "5deg",
        label: "Lobby",
        target: "interior03",
        type: "arrow"
      },
    ],
  },
  interior05: {
    name: "Bedroom 2",
    panorama: "/images/Interior05.jpg",
    thumbnail: "/images/thumbnail/Interior05.jpg",
    hotspots: [
      {
        id: "to-interior04",
        yaw: "-105deg",
        pitch: "5deg",
        label: "Bedroom 1",
        target: "interior04",
        type: "arrow"
      },
      {
        id: "to-interior03",
        yaw: "-120deg",
        pitch: "5deg",
        label: "Lobby",
        target: "interior03",
        type: "arrow"
      },
    ],
  },
  interior06: {
    name: "Bedroom 3",
    panorama: "/images/Interior06.jpg",
    thumbnail: "/images/thumbnail/Interior06.jpg",
    hotspots: [
      {
        id: "to-interior03",
        yaw: "-120deg",
        pitch: "5deg",
        label: "Lobby",
        target: "interior03",
        type: "arrow"
      },
    ],
  },
  interior07: {
    name: "Balcony",
    panorama: "/images/Interior07.jpg",
    thumbnail: "/images/thumbnail/Interior07.jpg",
    hotspots: [
      {
        id: "to-interior01",
        yaw: "110deg",
        pitch: "5deg",
        label: "Living Room",
        target: "interior01",
        type: "arrow"
      },
    ],
  },
};

export const buildingViews = [
  {
    day: "/images/DAY01.jpg",
    night: "/images/NIGHT01.jpg",
  },
  {
    day: "/images/DAY02.jpg",
    night: "/images/NIGHT02.jpg",
  },
  {
    day: "/images/DAY03.jpg",
    night: "/images/NIGHT03.jpg",
  },
  {
    day: "/images/DAY04.jpg",
    night: "/images/NIGHT04.jpg",
  },
];

export const exteriorTourOrder = ["exterior01", "exterior02", "exterior03", "exterior04", "exterior05", "exterior06", "exterior07"];

export const interiorTourOrder = ["interior01", "interior02", "interior03", "interior04", "interior05", "interior06", "interior07"];

export const brochure = "/images/Brochure.pdf";


export const hotspots = [
  {
    id: "A-101",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "1",
    type: "2BHK",
    unit: "1210",
    orientation: "West",
    polygon: `
    44.15,81.56
    46.33,82.12
    51.56,80.87
    51.70,85.20
    46.39,86.59
    43.95,86.17
    `,
  },
  {
    id: "A-102",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "1",
    type: "3BHK",
    unit: "1250",
    orientation: "East",
    polygon: `
    40.48,80.45
    42.52,81.28
    42.65,85.47
    40.48,84.92
    `,
  },
  {
    id: "A-103",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "1",
    type: "3BHK",
    unit: "1500",
    orientation: "West",
    polygon: `
      37.62,82.40
      43.95,84.08
      46.05,83.52
      46.26,87.01
      44.22,88.27
      37.62,87.01
    `,
  },
  {
    id: "A-104",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "1",
    type: "3BHK",
    unit: "1650",
    orientation: "East",
    polygon: `
      47.48,83.24
      47.62,87.57
      49.46,87.15
      49.52,83.38
    `,
  },
  {
    id: "A-201",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "2",
    type: "2BHK",
    unit: "1210",
    orientation: "West",
    polygon: `
    44.15,81.56
    46.33,82.12
    51.56,80.87
    51.70,85.20
    46.39,86.59
    43.95,86.17
    `,
  },
  {
    id: "A-202",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "2",
    type: "3BHK",
    unit: "1250",
    orientation: "East",
    polygon: `
    40.48,80.45
    42.52,81.28
    42.65,85.47
    40.48,84.92
    `,
  },
  {
    id: "A-203",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "2",
    type: "3BHK",
    unit: "1500",
    orientation: "West",
    polygon: `
      46.19,78.35
46.39,83.10
44.15,84.08
37.55,82.40
37.41,78.21
43.95,78.63
    `,
  },
  {
    id: "A-204",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "2",
    type: "3BHK",
    unit: "1650",
    orientation: "EAST",
    polygon: `
      47.55,78.49
      49.25,78.07
      49.32,81.98
      47.69,82.40
    `,
  },
  {
    id: "B-101",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "1",
    type: "2BHK",
    unit: "1210",
    orientation: "West",
    polygon: `
    44.15,81.56
    46.33,82.12
    51.56,80.87
    51.70,85.20
    46.39,86.59
    43.95,86.17
    `,
  },
  {
    id: "A-102",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "1",
    type: "3BHK",
    unit: "1250",
    orientation: "East",
    polygon: `
    40.48,80.45
    42.52,81.28
    42.65,85.47
    40.48,84.92
    `,
  },
  {
    id: "A-103",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "1",
    type: "3BHK",
    unit: "1500",
    orientation: "West",
    polygon: `
      37.62,82.40
      43.95,84.08
      46.05,83.52
      46.26,87.01
      44.22,88.27
      37.62,87.01
    `,
  },
  {
    id: "A-104",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "1",
    type: "3BHK",
    unit: "1650",
    orientation: "East",
    polygon: `
      47.48,83.24
      47.62,87.57
      49.46,87.15
      49.52,83.38
    `,
  },
  {
    id: "A-201",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "2",
    type: "2BHK",
    unit: "1210",
    orientation: "West",
    polygon: `
    44.15,81.56
    46.33,82.12
    51.56,80.87
    51.70,85.20
    46.39,86.59
    43.95,86.17
    `,
  },
  {
    id: "A-202",
    image: "/images/DAY01.jpg",
    tower: "A",
    floor: "2",
    type: "3BHK",
    unit: "1250",
    orientation: "East",
    polygon: `
    40.48,80.45
    42.52,81.28
    42.65,85.47
    40.48,84.92
    `,
  },
  {
    id: "A-203",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "2",
    type: "3BHK",
    unit: "1500",
    orientation: "West",
    polygon: `
      46.19,78.35
46.39,83.10
44.15,84.08
37.55,82.40
37.41,78.21
43.95,78.63
    `,
  },
  {
    id: "A-204",
    image: "/images/DAY04.jpg",
    tower: "A",
    floor: "2",
    type: "3BHK",
    unit: "1650",
    orientation: "EAST",
    polygon: `
      47.55,78.49
      49.25,78.07
      49.32,81.98
      47.69,82.40
    `,
  },
];